import React from 'react';
import { Typography, Card, Button, Space } from 'antd';
import { SecurityScanOutlined, SafetyOutlined, LockOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

const SecurityManagement = () => {
  return (
    <div className="admin-module">
      <div className="admin-module-header">
        <Title level={3} className="admin-module-title">Security Management</Title>
        <Text className="admin-module-description">
          Manage system security settings, including access control and restrictions
        </Text>
      </div>

      <Card>
        <div style={{ textAlign: 'center', padding: '40px 0' }}>
          <SecurityScanOutlined style={{ fontSize: '48px', color: '#f5222d', marginBottom: '16px' }} />
          <Title level={4}>Security Management</Title>
          <Text type="secondary">This feature is under development, stay tuned...</Text>
          <br /><br />
          <Space>
            <Button type="primary" icon={<SafetyOutlined />}>Security Scan</Button>
            <Button icon={<LockOutlined />}>Permission Settings</Button>
          </Space>
        </div>
      </Card>
    </div>
  );
};

export default SecurityManagement; 